export enum AssetType {
    Asset = 'asset',
    Folder = 'folder',
}
